// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1351F","insightsList":"newBusinessInsightsMenu_insightsList__30e-i","active":"newBusinessInsightsMenu_active__1aT7h"};